import type { SVGProps } from 'react';
const SvgFiberSmartRecord = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#fiber_smart_record_svg__a)">
      <path d="M9 20A8 8 0 1 0 9 4a8 8 0 0 0 0 16Z" />
      <path d="M17 4.26v2.09a5.99 5.99 0 0 1 0 11.3v2.09c3.45-.89 6-4.01 6-7.74 0-3.73-2.55-6.85-6-7.74Z" />
    </g>
    <defs>
      <clipPath id="fiber_smart_record_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiberSmartRecord;
